import { Pipe, PipeTransform } from '@angular/core';
import { NotebookSection, NotebookLibrary } from '../../descriptions/description.service';
@Pipe({
  name: 'getListItemText',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class GetListItemTextPipe implements PipeTransform {
  text: string = '';

  // This is creating an html string from the json object passed in
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  transform(section: NotebookSection, args?: any): string {
    const buildLibsString = (lib: NotebookLibrary): string => {
      const title_parts: (string | undefined)[] = [];
      let title = '';
      let lib_text = '';
      if ((lib.desc ?? '') !== '') {
        title_parts.push(lib.desc);
      }
      if ((lib.version ?? '') !== '') {
        title_parts.push(lib.version);
      }
      if (title_parts.length === 2) {
        title = title_parts[0] + ' - version: ' + title_parts[1];
      } else {
        title = title_parts.join('');
      }
      if (title !== '') {
        title = lib.name + ': ' + title;
      }
      if ((lib.url ?? '') !== '') {
        lib_text = '<a href="' + lib.url + '" title="' + title + '" rel="external">' + lib.name + '</a>';
      } else {
        lib_text = '<span title="' + title + '">' + lib.name + '</span>';
      }
      return lib_text;
    };

    // Joins the list of frangments with a proper oxford-comma join:
    // "a"; "a and b"; or "a, b, and c"
    const doOxfordCommaJoin = (lib_items: string[]): string => {
      let text: string = '';

      switch (lib_items.length) {
        case 0: {
          break;
        }
        case 1: {
          text = lib_items[0];
          break;
        }
        case 2: {
          text = lib_items.join(' and ');
          break;
        }
        default: {
          const last_item = lib_items.pop();
          text = lib_items.join(', ');
          text += ', and ' + last_item;
          break;
        }
      }
      return text;
    };

    const items: (string | undefined)[] = [];
    if ('prepend' in section) {
      items.push(section.prepend);
    }

    if (section.libraries) {
      const list_items: string[] = [];
      section.libraries.forEach((lib: NotebookLibrary) => {
        list_items.push(buildLibsString(lib));
      });
      if ((list_items.length ?? 0) !== 0) {
        items.push(doOxfordCommaJoin(list_items));
      }
    }

    if ('append' in section) {
      items.push(section.append);
    }

    this.text = items.join(' ');
    return this.text;
  }
}
